import React, { Component } from "react";
import Menu from './menu';
import { styled } from '@mui/material/styles';
import Helpers, { StorageHelper } from '../../helpers';
import { withRouter } from 'react-router-dom';
import SearchBox from '../searchbox';
import ExtendedSelect from '../select';
import logo from '../../logo.svg';
import StageImage from '../../stage.png';
import Config from '../../config';
import { Button } from '@mui/material';
import MenuButton from './menu_button';


const StageHeader = styled('div')({
    backgroundImage: Config.production ? '' : `url(${StageImage})`
});

class DocumentSearchBox extends Component {
    state = { term: new Helpers().queryString()['term'] || '' }
    onEnter = (e) => {
        this.props.history.push(`/search?term=${window.encodeURIComponent((e.currentTarget.value || '').replaceAll('%', ''))}`);
    }

    onChange = (e) => {
        this.setState({ term: e.currentTarget.value });
    }
    componentDidUpdate(p) {
        var term = new Helpers().queryString()['term'] || '';
        if (p.location.pathname !== this.props.location.pathname) {
            this.setState({ term: term });
        }
    }
    render() {
        return <SearchBox term={this.state.term || ''} handleChange={this.onChange} onEnter={this.onEnter} placeholder="Search documents" />;
    }
}

const RoutedDocumentSearchBox = withRouter(DocumentSearchBox);

const storageHelper = new StorageHelper();

class MenuContainer extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            visible: false
        };

        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);
        window.menuContainer = this;
        if (props.menuRef) {
            props.menuRef(this);
        }
    }
    handleMouseDown(e) {
        this.toggleMenu();
    }
    toggleMenu() {
        this.setState({
            visible: !this.state.visible
        });
    }

    componentDidMount = () => {
        this.updateTrackers();
    }

    componentDidUpdate(p) {
        if (this.props.location !== p.location) {
            this.updateTrackers();
            if (this.props.location.pathname !== p.location.pathname || this.queryDifferent(this.props.location.search, p.location.search)) {
                window.scrollTo(0, 0);
                // Only reset title if it hasn't been updated in the last 500ms
                // This gives components time to mount and set their own titles
                if (this.lastTitleUpdate < (new Date().getTime() - 500)) {
                    document.title = 'Logicbroker';
                }
            }
        }
    }

    setTitle = (title, includeInRecents) => {
        this.lastTitleUpdate = new Date().getTime();
        document.title = title;
        if (includeInRecents) {
            let path = window.location.pathname + window.location.search;
            let splitIndex = title.indexOf(':');
            if (splitIndex < 0) {
                splitIndex = 0;
            } else {
                splitIndex += 2;
            }
            title = title.substring(splitIndex, title.length);
            let entry = { title, path };
            let recents = storageHelper.get("lb-recents") || [];
            let existing = recents.filter(r => r.path === path).length;
            if (existing > 0) {
                recents = recents.filter(r => r.path !== path);
            } else {
                recents = recents.slice(0, 4);
            }
            recents = [entry, ...recents];
            storageHelper.set("lb-recents", recents);
            window.dispatchEvent(new StorageEvent('storage', { key: 'lb-recents' }));
        }
    }

    queryDifferent(oldSearch, newSearch) {
        let oldParams = new URLSearchParams(oldSearch);
        let newParams = new URLSearchParams(newSearch);
        let excludedParams = ['q_page'];
        for (const [key, value] of oldParams.entries()) {
            if (excludedParams.indexOf(key) > -1) {
                continue;
            }
            if (!newParams.has(key) || newParams.get(key) !== value) {
                return true;
            }
        }
        for (const [key, value] of newParams.entries()) {
            if (excludedParams.indexOf(key) > -1) {
                continue;
            }
            if (!oldParams.has(key) || oldParams.get(key) !== value) {
                return true;
            }
        }
        return false;
    }

    updateTrackers() {
        try {
            window.Appcues.page();
        }
        catch (e) {
            //do nothing
        }
        try {
            window.gtag('config', Config.googleAnalytics, { 'page_path': this.props.location.pathname });
        } catch (e) {
            //do nothing
        }
    }

    selectValue(value) {
        if (this.select) {
            this.select.setValue(value);
        }
    }

    render() {
        let { companyName, coid, companies, onCompanySwitch, children, history, location, menuRef, ...otherProps } = this.props;
        var className = 'app-header';
        if (!Config.production) {
            className += " stage";
        }
        var line1ClassName = 'app-header-line1';
        var line2ClassName = 'app-header-line2';
        var lineHolder = 'app-header-line-holder';
        if (this.state.showSearch === true) {
            line2ClassName += ' show';
            line1ClassName += ' hide';
            lineHolder += ' show-search';
        }
        return (
            <div className='menu-holder' style={{ flexDirection: 'row', display: 'flex', flex: "1 1 auto" }}>
                <StageHeader className={className} style={{ position: 'fixed', top: 0, zIndex: 30, width: '100%' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <div className='header-button'><MenuButton handleMouseDown={this.toggleMenu} isOpen={this.state.visible} /></div>
                    </div>
                    <div className={lineHolder}>
                        <div className={line1ClassName}>
                            <div className='logo-holder'>
                                <a style={{ display: 'flex' }} href="https://www.logicbroker.com" target="_blank" rel="noreferrer noopener"><img src={logo} alt="Logicbroker" /></a>
                            </div>
                            <div data-testid="company-select" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '20em', fontSize: '16px' }}>{companies && companies.length > 1 ?
                                <ExtendedSelect ref={r => this.select = r} style={{ background: 'white', borderRadius: '6px' }} variant='outlined' placeholder='Select company...' onChange={onCompanySwitch} value={coid} options={companies.map((i) => { return { label: i.Item2, value: i.Item1 }; })} />
                                : companyName}</div>
                        </div>
                        <div className={line2ClassName}>
                            <div className='app-search-holder'>
                                <RoutedDocumentSearchBox />
                            </div>
                            <div className='app-toggle-search' style={{ alignSelf: 'center' }}><Button style={{ backgroundColor: 'white' }} variant='outlined' color='primary' onClick={() => this.setState({ showSearch: !this.state.showSearch })}>{this.state.showSearch ? 'Hide' : 'Search'}</Button></div>
                        </div>
                    </div>
                </StageHeader>
                <Menu menuVisibility={this.state.visible} {...otherProps} />
                <div className='app-content-parent' style={{ flex: 1, display: 'flex', 'flexDirection': 'column' }}>{children}</div>
            </div>
        );
    }
}

export default withRouter(MenuContainer);
